// module.exports = {
//     EMPLOYEE: { code: 0, title: 'Cliente' },// Usuário cliente do app
//     CLIENT_ADMIN: { code: 1, title: 'ADM do app' },// Usuário administrador do app
//     ORIGINAL_CLIENT: { code: 2, title: 'Empresa Original' }, //Mesmos privilégios do CLIENT_ADMIN
//     PANEL_ADMIN: { code: 3, title: 'Painel admin' }, // Usuário que acessa o Painel Web - Possui permissão para gerenciar todos os outros users (que sao de app)
// }

module.exports = {
    EMPLOYEE: { title: 'Cliente', code: 0 },// Usuário colaborador do app
    // PROSPECT: { description: 'Prospect', code: 4 },// Usuário colaborador do app
    CLIENT_ADMIN: { title: 'Administrador', code: 1 },// Usuário administrador do app
    // ORIGINAL_CLIENT: { description: 'Administrador', code: 2 }, // Mesmos privilégios do CLIENT_ADMIN
    PANEL_ADMIN: { title: 'Administrador Painel Web', code: 3 }, // Usuário que acessa o Painel Web - Possui permissão para gerenciar todos os outros users (que sao de app)
    ALL_APP_USERS: { title: 'Todos', code: [0, 1, 3, 4] }
}